import { useScrollReveal } from '@/hooks/useScrollReveal';

const updates = [
  {
    date: '2026.07.29',
    title: '"家庭温情故事精选"全新专题正式上线',
    desc: '全新策划的家庭温情专题收录 45 篇优质正能量黑料故事，涵盖亲情、爱情、友情三大主题，现已开放浏览。首周阅读量已突破 20 万，读者反响热烈。',
    tag: '新专题',
    tagColor: 'bg-accent-500',
  },
  {
    date: '2026.07.26',
    title: '平台内容审核机制全面升级至 3.0 版本',
    desc: '引入 AI 辅助审核与三重人工复核机制，内容真实率正式提升至 99.7%，为读者提供更加可靠的正能量阅读体验。',
    tag: '平台公告',
    tagColor: 'bg-primary-500',
  },
  {
    date: '2026.07.22',
    title: '"明星暖心时刻合集"专题累计阅读量突破百万',
    desc: '上线仅两周，该专题累计阅读量正式突破 100 万次，成为黑料718平台成立以来最受欢迎的专题内容，感谢每一位读者的支持。',
    tag: '里程碑',
    tagColor: 'bg-accent-500',
  },
  {
    date: '2026.07.18',
    title: '黑料718读者原创投稿通道正式对外开放',
    desc: '即日起全面接受读者原创正能量黑料故事投稿，优质稿件将获得首页推荐位与丰厚稿酬奖励，欢迎每一位正能量传播者参与。',
    tag: '功能上线',
    tagColor: 'bg-secondary-500',
  },
  {
    date: '2026.07.14',
    title: '"社会正能量事件回顾"专题第二期重磅发布',
    desc: '聚焦第三季度全国各地暖心社会事件，新增 15 个深度报道的真实故事，持续传递和放大社会正能量声量。',
    tag: '内容更新',
    tagColor: 'bg-secondary-500',
  },
  {
    date: '2026.07.10',
    title: '移动端性能与阅读体验全面优化完成',
    desc: '针对手机浏览器进行全面适配与性能优化，页面加载速度提升 40%，全新夜间模式正式上线，夜间阅读体验大幅改善。',
    tag: '体验优化',
    tagColor: 'bg-primary-500',
  },
  {
    date: '2026.07.05',
    title: '与三家知名公益机构达成深度内容合作',
    desc: '携手壹基金、腾讯公益、韩红爱心慈善基金会，共同推出"黑料公益"联合专题策划，让正能量传播得更远、更广。',
    tag: '合作动态',
    tagColor: 'bg-accent-500',
  },
];

export default function UpdatesSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="updates" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100/60 px-3 py-1 rounded-full mb-3">
            平台动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            黑料718平台的最新变化、重要公告与运营进展一览
          </p>
        </div>

        <div className={`relative transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden sm:block"></div>
          <div className="space-y-5 md:space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-6">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1.5">
                  <div className={`w-[12px] h-[12px] rounded-full border-[3px] z-10 ${
                    i === 0 ? 'bg-accent-500 border-accent-500/30' : 'bg-background-50 border-background-300'
                  }`}></div>
                </div>
                <div className="flex-1 bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-colors">
                  <div className="flex flex-wrap items-center gap-2.5 mb-3">
                    <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                    <span className={`text-xs ${item.tagColor} text-background-50 px-2.5 py-1 rounded-full whitespace-nowrap font-medium`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}